import { render } from "./UserCardSkeleton.vue?vue&type=template&id=0743946e&scoped=true"
import script from "./UserCardSkeleton.vue?vue&type=script&lang=js"
export * from "./UserCardSkeleton.vue?vue&type=script&lang=js"

import "./UserCardSkeleton.vue?vue&type=style&index=0&id=0743946e&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0743946e"]])

export default __exports__